;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	var Model = APP.module('Model');
	View.SendToken = Marionette.ItemView.extend({
		tagName: 'div',
		ui: {
			'email': '#send-token-input',
			'form': '#send-token-form',
			'submit': '#send-token-button'
		},
		events: {
			'click @ui.submit': 'sendToken',
			'submit @ui.form': 'sendToken'
		},

		initialize: function(){
			this.errors = false;
			this.option = this.getOption('options');
			this.form = new Backbone.Form({
				template: JST.sendToken,
				model: this.model
			});
			this.listenTo(this.form, 'email:change email:blur', this.changeAndBlur);
		},

		render: function(){
			this.$el.html(this.form.render().el);
			this.scrollToTop();
			return this;
		},

		changeAndBlur: function(form, editor){
			var $el = $(editor.el);

			// Trim value on change of field, emails will never have a space in it
			$el.val($el.val().trim());

			if(!editor.getValue()){
				this.errors = true;
				$el.removeClass('valid');
				$el.parents('.error').removeClass('error');
				$el.parent().next('div').html('');
				return;
			}
			var errs = this.form.fields[editor.key].validate();

			this.errors = Boolean(errs);

			!errs && editor.previousValue ? $el.addClass('valid') : $el.removeClass('valid');
			return this;
		},

		sendToken: function() {
			this.form.validate();
			this.showPreloader();


			if(!this.errors && this.form.getValue('email').length){

				this.model.set('email', this.form.getValue('email'));
				$.when.call(null , this.model.save()).done(_.bind(function(response){
					if(response.errors.length){
						this.showErrors(response.errors);
						this.hidePreloader();
					}
					else {
						alert("Thank you. An email has been sent to you with a link to reset your password.");
						var url = CONFIG.FRONT_PROTOCOL + '//' + CONFIG.FRONT_HOST + CONFIG.FRONT_PATH;
						window.location.href = url;
					}
				}, this));
			}
			this.hidePreloader();
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));